import React from 'react';
import { Pills } from '@saleshandy/design-system';

import { truncate } from '../../../../../../../shared/utils';

export const renderPills = (
  selectedOptions: { key: string; name: string; value?: string[] }[],
  onChange: (keys: string[]) => void,
  disabled: boolean,
  maxChipsToShow = 2,
) => {
  const visibleChips = selectedOptions.slice(0, maxChipsToShow);
  const remainingChips = selectedOptions.slice(
    visibleChips.length - selectedOptions.length,
  );

  return (
    <>
      {visibleChips.map(
        (option, index) =>
          option?.name && (
            <Pills
              key={`render-pill-${option?.key}-${index + 1}`}
              label={truncate(option?.name || '', 10, false)}
              size="md"
              showCloseIcon
              onClose={() => {
                if (!disabled) {
                  onChange(
                    selectedOptions
                      .filter((item) => item?.key && item.key !== option?.key)
                      .flatMap((item) => {
                        if (item?.value && Array.isArray(item?.value)) {
                          return item.value;
                        }
                        return item?.key;
                      }),
                  );
                }
              }}
            />
          ),
      )}

      {selectedOptions?.length > maxChipsToShow && remainingChips?.length > 0 && (
        <Pills
          label={`+${remainingChips.length}`}
          size="md"
          showCloseIcon
          onClose={() => {
            if (!disabled) {
              const keysToRemove =
                remainingChips
                  .filter(
                    (item): item is { key: string; name: string } =>
                      item !== undefined,
                  )
                  .map((item) => item?.key) || [];

              onChange(
                selectedOptions
                  .filter(
                    (item) => item?.key && !keysToRemove.includes(item?.key),
                  )
                  .flatMap((item) => {
                    if (item?.value && Array.isArray(item?.value)) {
                      return item.value;
                    }
                    return item?.key;
                  }),
              );
            }
          }}
        />
      )}
    </>
  );
};
